import React, { lazy, Suspense, useState } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18n from "./i18n";
import splashPage from "./pages/splashPage";
import ErrorHandler from "./components/ErrorHandler";

const EmployeeReferral = lazy(() => import("./pages/EmployeeReferral"));
const SbsReferrals = lazy(() => import("./pages/SbsReferrals"));
const EvsForm = lazy(() => import("./pages/evsForm"));
const PoeForm = lazy(() => import("./pages/poeForm"));
const VerifiedPage = lazy(() => import("./pages/verified"));
const Referral = lazy(() => import("./pages/referral"));
const EmployeeEmailSignUp = lazy(() => import("./pages/EmployeeEmailSignUp"));
const FFHDiscountApplication = lazy(() =>
  import("./pages/ffhDiscountApplication")
);
const CustomForm = lazy(() => import("./pages/CustomForm"));
const Affiliates = lazy(() => import("./pages/affiliates"));
const VerifiedAffiliate = lazy(() => import("./pages/verifiedAffiliate"));
const IqForm = lazy(() => import("./pages/iq"));

const baseRouteUrl = "/:locale(fr|en)?";
export const baseUrl = i18n.language === "en" ? "" : `/${i18n.language}`;

// Application routing.
function App(props) {
  const { t } = props;
  const [internalServerError, setInternalServerError] = useState(false);
  return (
    <BrowserRouter>
      <ErrorHandler internalServerError={internalServerError}>
        <Suspense fallback={<div>{t("loading")}</div>}>
          <Switch>
            <Route path={`${baseRouteUrl}/`} exact>
              <EvsForm />
            </Route>
            <Route path={`${baseRouteUrl}/evs`} exact>
              <EvsForm setInternalServerError={setInternalServerError} />
            </Route>
            <Route path={`${baseRouteUrl}/evs/proof-of-employment`}>
              <PoeForm setInternalServerError={setInternalServerError} />
            </Route>
            <Route path={`${baseRouteUrl}/evs/verified`}>
              <VerifiedPage setInternalServerError={setInternalServerError} />
            </Route>
            <Route path={`${baseRouteUrl}/evs/referral`}>
              <Referral setInternalServerError={setInternalServerError} />
            </Route>
            <Route path={`${baseRouteUrl}/evs/solutions-credit`}>
              <FFHDiscountApplication
                setInternalServerError={setInternalServerError}
              />
            </Route>
            <Route path={`${baseRouteUrl}/evs/sbs-referrals`}>
              <SbsReferrals setInternalServerError={setInternalServerError} />
            </Route>
            <Route path={`${baseRouteUrl}/evs/employee-referral`}>
              {/* eslint-disable-next-line */}
              <EmployeeReferral setInternalServerError={setInternalServerError} />
            </Route>
            <Route path={`${baseRouteUrl}/evs/employee-email-sign-up`}>
              <EmployeeEmailSignUp
                setInternalServerError={setInternalServerError}
              />
            </Route>
            <Route path={`${baseRouteUrl}/evs/form`}>
              {/* eslint-disable-next-line */}
              <CustomForm formType="rebate" setInternalServerError={setInternalServerError} />
            </Route>
            <Route path={`${baseRouteUrl}/evs/event`}>
              {/* eslint-disable-next-line */}
              <CustomForm formType="event" setInternalServerError={setInternalServerError} />
            </Route>
            <Route path={`${baseRouteUrl}/evs/evenement`}>
              {/* eslint-disable-next-line */}
              <CustomForm formType="event" setInternalServerError={setInternalServerError} />
            </Route>
            <Route path={`${baseRouteUrl}/evs/admin/form`}>
              {/* eslint-disable-next-line */}
              <CustomForm formType="admin" setInternalServerError={setInternalServerError} />
            </Route>
            <Route path={`${baseRouteUrl}/telus-iq`} exact>
              <IqForm setInternalServerError={setInternalServerError} />
            </Route>
            <Route
              path={`${baseRouteUrl}/affiliates/verified`}
              render={(prop) => (
                <VerifiedAffiliate
                  setInternalServerError={setInternalServerError}
                  {...prop} // eslint-disable-line
                />
              )}
            />
            <Route
              path={`${baseRouteUrl}/affiliates/:brandedUrl`}
              render={(prop) => (
                <Affiliates
                  setInternalServerError={setInternalServerError}
                  {...prop} // eslint-disable-line
                />
              )}
            />
            <Route
              path={`${baseRouteUrl}/splash-page`}
              component={splashPage}
            />
          </Switch>
        </Suspense>
      </ErrorHandler>
    </BrowserRouter>
  );
}

App.propTypes = {
  t: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    language: PropTypes.string,
  }).isRequired,
};

export default withTranslation()(App);
